<script>
  import Vue from 'vue';
  import {Collection} from 'vue-mc';

  export default {
    name: 'BaseServerTable',
    components: {},
    props: {
      collection: {
        type: Object,
        default: function () {
          return {};
        }
      },
      show_columns: {
        type: Array,
        default: function () {
          return []
        }
      },
      filterable: {
        type: Array,
        default: function () {
          return []
        }
      },
      sortable: {
        type: Array,
        default: function () {
          return []
        }
      }
    },
    data: function () {
      return {
        table_config: {
          options: {
            requestFunction: this.requestFunction,
            responseAdapter: this.responseAdapter,
          },
        },
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default',
        ref: 'table-'+this.$uuid.v1(),
        customFilters: {},
      }
    },
    methods: {

      getDefaultTableConfig() {
        return {
          columns: this.show_columns,
          options: {
            sortable: this.sortable,
            debounce: 400,
            filterable: this.filterable,
            sortIcon: {base: 'fa', up: 'fa-sort-asc', down: 'fa-sort-desc', is: 'fa-sort'},
            texts: {filter: 'Search:', filterPlaceholder: '', limit: 'Per Page:'},
            pagination: {
              chunk: 5,
              edge: false,
              nav: 'scroll'
            },
          }
        }
      },
      /**
       *
       */
      isCollectionSet() {
        return (this.collection instanceof Collection);
      },
      /**
       * Check if the column should be shown
       * @param key
       * @return boolean
       */
      showColumn(key) {
        return this.show_columns.indexOf(key) !== -1;
      },
      /**
       *
       * @param data
       * @returns {Promise<any>}
       */
      requestFunction(data) {
        this.applyFilterParams(data);
        this.applyExtraFilterParams(data);

        // run request
        return new Promise((resolve, reject) => {
          this.collection.fetch().then((response) => {
            if (response && response.getStatus() === 200) {
              resolve(this.collection);
            } else {
              reject();
            }
          });
        });
      },
      applyFilterParams(data) {

        // cache filter
        let Filter = this.collection.getFilter();

        // reset the filter
        Filter.resetSort();
        Filter.resetDefaultSort();
        Filter.resetFilters();

        // let implementing component prepare the filter
        this.prepareCollectionFilter(Filter);

        // add order by
        if (data.orderBy) {
          Filter.sortAdd(data.orderBy, (data.ascending ? 'ASC' : 'DESC'));
        }

        // add filters
        if (data.query && Array.isArray(this.filterable)) {
          this.filterable.forEach((filterBy) => {
            Filter.filterContains(filterBy, data.query, 'orWhere');
          });
        }

        if(this.customFilters) {
          for(let filterKey in this.customFilters) {
            let filter = this.customFilters[filterKey];
            Filter.filterAdd(filter.field, filter.operator, filter.value, filter.logic);
          }
        }

        // add limit and page to collection filter
        Filter.setLimit(data.limit);
        Filter.setPage(data.page);

      },
      /**
       * To add more filters along with applyFilterParams
       * Override to add more filter ex. Filter.search = data.query
       */
      applyExtraFilterParams(data) {
      },
      /**
       * function used to prepare the filter prior to requesting data
       * Override to set required connections, ordering, etc.
       * @param CollectionFilter
       */
      prepareCollectionFilter(CollectionFilter) {
      },
      /**
       *
       * @param collection
       * @returns {*}
       */
      responseAdapter(collection) {
        if(collection) {
          return {
            data: collection.models,
            count: collection.get('count')
          };
        }
        return null;
      },
      setCustomFilter(key, filter) {
        if(filter && filter !== '') {
          this.customFilters[key] = filter;
        } else {
          delete this.customFilters[key];
        }
        this.$refs[this.ref].refresh();
      },
      triggerModelDelete(data) {
        let model = data.model;
        let index = data.index;
        this.$bvModal.msgBoxConfirm('You are about to remove this item. Do you want to continue?', {
          title: 'Are you sure?',
          modalClass: ['modal-danger'],
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          centered: true
        }).then(() => {
          this.$bvToast.toast('This will take a second.', {
            'title': 'Deleting',
            'variant': 'info'
          });
          model.delete().then(() => {
            this.$bvToast.toast('The table will now refresh...', {
              'title': 'Deleted Successfully',
              'variant': 'success'
            });
            this.$refs[this.ref].refresh();
            this.$emit('onModelDeleteSuccess', {model, index});
          }).catch((err) => {
            console.warn('DELETE FAIL', err);
            this.$bvToast.toast('Please try again later.', {
              'title': 'Deleted Failed',
              'variant': 'danger'
            });
            this.$emit('onModelDeleteFailure', {model, index});
          });
        });
      }
    }
  };
</script>
